import { render, staticRenderFns } from "./AcessarDocumentosPenalidadesPedidoBtnMaisAcoes.vue?vue&type=template&id=29e007a4&scoped=true"
import script from "./AcessarDocumentosPenalidadesPedidoBtnMaisAcoes.vue?vue&type=script&lang=js"
export * from "./AcessarDocumentosPenalidadesPedidoBtnMaisAcoes.vue?vue&type=script&lang=js"
import style0 from "./AcessarDocumentosPenalidadesPedidoBtnMaisAcoes.vue?vue&type=style&index=0&id=29e007a4&prod&scoped=true&lang=stylus"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29e007a4",
  null
  
)

export default component.exports